<template>
    <!-- 库存列表 -->
    <vRepertoryListComponent :postList="postList" v-if="flag"></vRepertoryListComponent>
</template>
<script>
import vRepertoryListComponent from '../../listComponent/basicdata/repertoryList/repertoryListComponent.vue';
export default {
    name: 'repertoryList',
    components: {
        vRepertoryListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                source_account_rid: true,
                source_file: true,
                product_rid: true,
                product_owner_rid: true,
                supplier_rid: true,
                no_demander: true,
                no_supplier: true,
                no_product: true,
                no_product_owner: true,
                no_business: true,
                no_partner: true,
                no_principal: true,
                start_date: true,
                end_date: true,
                source_account_code: true,
                rid: true,
                dateValue: true,
                updateBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>